import { SellerSubscriptionApi } from '../../generated/api';
import configuration from './configuration';

export default new SellerSubscriptionApi(configuration);
